import { PixelBuffer } from "../pixel/PixelBuffer";
import type { Selection } from "../selection/Selection";
import type { Filter } from "./Filter";

export interface FibersParams {
  variance: number;
  strength: number;
}

export const Fibers: Filter<FibersParams> = {
  id: "fibers",
  displayName: "Fibers",
  defaultParams: { variance: 16, strength: 50 },

  apply(input: PixelBuffer, params: FibersParams, _selection: Selection | null): PixelBuffer {
    const w = input.width;
    const h = input.height;
    const out = new PixelBuffer(w, h, input.mode);
    const dst = out.data;

    if (w === 0 || h === 0) return out;

    const variance = params.variance;
    const strength = params.strength / 100;

    for (let y = 0; y < h; y++) {
      for (let x = 0; x < w; x++) {
        const o = (y * w + x) * 4;
        const noise = (Math.random() - 0.5) * variance;
        const fiber = Math.sin(x * 0.1 + y * 0.05 + noise) * strength;
        const val = Math.round(128 + fiber * 127 + noise * 2);
        dst[o] = clamp8(val);
        dst[o + 1] = clamp8(val - 20);
        dst[o + 2] = clamp8(val + 20);
        dst[o + 3] = 255;
      }
    }
    return out;
  },
};

function clamp8(v: number): number {
  return v < 0 ? 0 : v > 255 ? 255 : v;
}
